import Page from 'components/modules/public/pages/ArticleEmployee';
export default Page;